export const environment = {
  production: false,
  api_url: `https://test.webapp.mejorninez.cl/api`,
  //api_url: `https://oirsv2-api-dev-staging-d8emgxabhhcyg4f6.chilecentral-01.azurewebsites.net/api`, // API dev directa (sin proxy)
  //api_url: `http://localhost:80/api`,
  //api_url: `https://mejorninez-backend.azurewebsites.net/api`,
  prefix: 'dev.',
  firebaseConfig: {
    test: {
      apiKey: "AIzaSyDrQ5CcALrxvFGd0l4VLvBQyMOjSfEGCyg",
      authDomain: "app-mejor-ninez.firebaseapp.com",
      projectId: "app-mejor-ninez",
      storageBucket: "app-mejor-ninez.appspot.com",
      messagingSenderId: "675752708359",
      appId: "1:675752708359:web:78931f1e655f8e9c0bdda2",
      measurementId: "G-L13KXHC80C"
    },
    prod: {},
    development: {
      apiKey: "AIzaSyDrQ5CcALrxvFGd0l4VLvBQyMOjSfEGCyg",
      authDomain: "app-mejor-ninez.firebaseapp.com",
      projectId: "app-mejor-ninez",
      storageBucket: "app-mejor-ninez.appspot.com",
      messagingSenderId: "675752708359",
      appId: "1:675752708359:web:78931f1e655f8e9c0bdda2",
      measurementId: "G-L13KXHC80C"
    }
  },
  facebookUrl: 'https://www.facebook.com/Mejor-Ni%C3%B1ez-110326244492990',
  instagramUrl: 'https://www.instagram.com/mejorninez/?hl=es',
  twitterUrl: 'https://twitter.com/MejorNinez',
  survey_app_url: 'https://test.webapp.mejorninez.cl',
  appInsights: {
    connectionString: 'InstrumentationKey=b2317d7b-3e21-42d3-bd8e-3ad37c12647a;IngestionEndpoint=https://brazilsouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://brazilsouth.livediagnostics.monitor.azure.com/;ApplicationId=6e0d72df-c729-462b-b147-758178c9c07a',
    instrumentationKey: 'b2317d7b-3e21-42d3-bd8e-3ad37c12647a'
  }
};
